import React from 'react';
// @ts-ignore
import Warning from '../../assets/icons/Warning.svg';
import './TenantSelection.scss';
//  import { SessionStorageKeys } from '../../constants';
// import ExpiryNotification from './ExpiryNotification';
// import { RouteComponentProps, withRouter } from 'react-router-dom';
// import { withErrorBoundary } from '../../Services/ErrorBoundary';

type Props = {
  // setPassExpCase: any;
  // history: RouteComponentProps;
};

const NoTenants = (props: Props) => {
  // const userData = window.sessionStorage.getItem(
  //   SessionStorageKeys.UserData
  // );
  // const [PasswordUpdateSuccess, setPasswordUpdateSuccess] = React.useState('');
  // const [passExpMsg, setpassExpMsg] = React.useState('');

  // React.useEffect(() => {
  //   let PasswordUpdateSuccess = localStorage.getItem('PasswordUpdateSuccess');
  //   if (PasswordUpdateSuccess) {
  //     setPasswordUpdateSuccess(PasswordUpdateSuccess);
  //     localStorage.removeItem('PasswordUpdateSuccess');
  //   } else if (window.sessionStorage) {
  //     const userData = window.sessionStorage.getItem(
  //       SessionStorageKeys.UserData
  //     );
  //     if (userData && JSON.parse(atob(userData)).notify) {
  //       if (JSON.parse(atob(userData)).passExp) {
  //         setpassExpMsg(JSON.parse(atob(userData)).passExp);
  //       }
  //     }
  //   }
  // }, []);
  return (
    <>
      <div className='no-tenant-wrapper'>
        <div className='nt-img'>
          <img src={Warning} />
        </div>
        <div className='nt-header'>No tenants or bots</div>
        <div className='nt-content'>
          It seems you are no longer a part of any bot team. Please contact your Admins.
          Or reach out to Hybrid Chat Support.
        </div>
      </div>
      {/* {passExpMsg || PasswordUpdateSuccess === 'true' ? (
        <ExpiryNotification
          msg={
            PasswordUpdateSuccess === 'true'
              ? 'Your password was set successfully'
              : passExpMsg
          }
          type={
            PasswordUpdateSuccess === 'true' ? 'success' : 'warning'
          }
          setPassExpMsg={() => setpassExpMsg('')}
          setPassExpCase={props.setPassExpCase}
          userId={userData && JSON.parse(atob(userData)).userId}
          history={props.history}
        />
      ) : null} */}
    </>
  );
};

export default NoTenants;
